import { useApi } from '../hooks/useApi';

interface Credential {
  id: string;
  name: string;
  type: string;
  issuingBody: string | null;
}

const TrustedByStrip = () => {
  const { data: credentials } = useApi<Credential[]>('/credentials');

  const items = credentials && credentials.length > 0
    ? credentials
    : [
        { id: '1', name: 'Featured on ABC', type: 'MEDIA', issuingBody: null },
        { id: '2', name: 'Proud Supporters of Make-A-Wish', type: 'COMMUNITY', issuingBody: null },
        { id: '3', name: '4+ Years Touring Shows, Expos & Festivals', type: 'EXPERIENCE', issuingBody: null },
        { id: '4', name: 'Tamworth Country Music Festival', type: 'EXPERIENCE', issuingBody: null },
        { id: '5', name: '2025 Quality Business Finalist', type: 'AWARD', issuingBody: 'Tamworth' },
      ];

  const doubled = [...items, ...items];

  return (
    <section className="py-6 bg-charcoal border-y border-charcoal-700 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap">
        {doubled.map((cred, i) => (
          <div
            key={`${cred.id}-${i}`}
            className="inline-flex items-center gap-2 mx-8 shrink-0"
          >
            <span className="w-2 h-2 rounded-full bg-jp-red shrink-0" />
            <span className="font-display text-sm uppercase tracking-wider text-cream/70">
              {cred.name}
            </span>
            {cred.issuingBody && (
              <span className="text-sm text-amber/60 font-mono">
                ({cred.issuingBody})
              </span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustedByStrip;
